<template>
	<div>
		<ToolBar :class="currentPath" />
		<div class="main-page">
			<router-view />
		</div>
	</div>
</template>

<script>
import ToolBar from '../layout/ToolBar.vue'
export default {
	components: { ToolBar },
	computed: {
		currentPath() {
			let pathName = this.$route.name
			switch (pathName) {
				case 'MyOrder':
					return ''
					break
				default:
					return 'addShadow'
					break
			}
		},
	},
}
</script>

<style lang="sass" scoped>
.main-page
  margin-top: 50px

.addShadow
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.16)
</style>
